import type { Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { EntryGuard } from './core/auth/entry.guard';

export const routes: Routes = [
  {
    path: '',
    canMatch: [() => EntryGuard()],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/home/home.component').then(
            (mod) => mod.HomeComponent,
          ),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./components/admin/admin.routes').then(
            (mod) => mod.ADMIN_ROUTES,
          ),
      },
      {
        path: 'arrive-depart',
        loadChildren: () =>
          import('./components/operations/operations.routes').then(
            (mod) => mod.OPERATIONS_ROUTES,
          ),
      },
      {
        path: 'revenue-recovery',
        loadChildren: () =>
          import('./components/revenue-recovery/revenue-recovery.routes').then(
            (mod) => mod.REVENUE_RECOVERY_ROUTES,
          ),
      },
      {
        path: 'inbound',
        loadChildren: () =>
          import('./components/inbound/inbound.routes').then(
            (mod) => mod.INBOUND_ROUTES,
          ),
      },
      {
        path: 'position-operations',
        loadChildren: () =>
          import('./components/position-operations/position-operations.routes').then(
            (mod) => mod.POSITION_BASED_OPS_ROUTES,
          ),
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./components/customer/customer.routes').then(
            (mod) => mod.CUSTOMER_ROUTES,
          ),
      },
      {
        path: 'sci',
        loadChildren: () =>
          import('./SCI/components/sci.routes').then((mod) => mod.SCI_ROUTES),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./components/reports/reports.component').then(
            (mod) => mod.ReportsComponent,
          ),
      },
      {
        path: 'logout',
        loadComponent: () =>
          import('./components/side-nav/logout/logout.component').then(
            (mod) => mod.LogoutComponent,
          ),
      },
      {
        path: 'auth',
        component: MsalRedirectComponent,
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./components/login/login.component').then(
            (mod) => mod.LoginComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'dashboard',
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./components/side-nav/logout/logout.component').then(
        (mod) => mod.LogoutComponent,
      ),
  },
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  { path: '**', redirectTo: '' },
];
